/* eslint-disable @typescript-eslint/camelcase */
import _ from 'lodash';
import { Config } from '../config';

export const isLocalhost = () => _.includes(window.location.host, 'localhost');

export const IsDevelopment = Config.isProduction === false;

export const LoginRedirectUrl = `${Config.authRedirect}/auth`;
